import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-deletion',
  templateUrl: './data-deletion.component.html',
  styleUrls: ['./data-deletion.component.scss']
})
export class DataDeletionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
